import React from 'react';

const SvgParagraph = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20.444 6.152V4.4a.4.4 0 0 0-.4-.4h-9.818A6.9 6.9 0 0 0 5.68 5.308 4.784 4.784 0 0 0 4 9.191a5.051 5.051 0 0 0 1.672 4.115 7.316 7.316 0 0 0 4.839 1.432h1.818v5.789a.4.4 0 0 0 .4.4h1.243a.4.4 0 0 0 .4-.4V6.551h1.6v13.976a.4.4 0 0 0 .4.4h1.2a.4.4 0 0 0 .4-.4V6.551h2.072a.4.4 0 0 0 .4-.399z" />
  </svg>
);

export default SvgParagraph;
